<template>
  <div class="td current-site">
    <div class="current-site-picture" :style="{ backgroundImage: `url(${data.image})` }"></div>
    <span class="current-poi"></span>

    <div class="details">
      <span class="title">
        {{ data.caption }}
      </span>

      <div v-if="(optimizedTransport && indexPages === 0) || forcedTransport === 'optimized'" class="matching-time-container wrap">
        <span class="matching-time">
          <i class="icon icon-bus"></i>
          {{ transportDistribution.optimized.public }}%
        </span>
        <span class="matching-time">
          <i class="icon icon-car"></i>
          {{ transportDistribution.optimized.car }}%
        </span>
        <span v-if="study.withWalkingTimes" class="matching-time">
          <i class="icon icon-cycle"></i>
          {{ transportDistribution.optimized.bicycle }}%
        </span>
        <span v-if="study.withWalkingTimes" class="matching-time">
          <i class="material-icons">directions_walk</i>
          {{ transportDistribution.optimized.walking }}%
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    data: {
      type: Object,
    },

    forcedTransport: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters({
      study: 'study',
      globalFilters: 'globalFilters',
      indexPages: 'indexPages',
      transportDistribution: 'transportDistribution',
    }),

    optimizedTransport() {
      return this.globalFilters.currentMatchingTime === 'optimized';
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.td.current-site {
  display: flex;
  align-items: center;
  width: 236px;
  flex: none;

  .current-site-picture {
    flex-shrink: 0;
    height: 2px;
    width: 9.375em;
    border-radius: 0.625em;
    margin-left: 1.3em;
    margin-right: 1.3em;
  }

  .current-poi {
    flex-shrink: 0;
    height: 24px;
    display: inline-block;
    width: 5em;
    margin-left: 9.375em;
    background-size: contain;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-image: url('./../../assets/Marker-home.png');
    color: white;
    text-align: center;
    box-sizing: border-box;
    padding-top: 0.875em;
    font-weight: 700;

    height: 32px;
    width: 2em;
    margin-left: -31px;
    margin-bottom: -6px;
  }

  .details {
    flex-shrink: 0;
    flex: 1;

    .title {
      // margin: 0 0 0 116px;
      font-size: 1em;
      font-weight: 700;
      color: #3c3c3b;
    }

    .matching-time-container {
      &.wrap {
        display: flex;
        flex-wrap: wrap;
      }

      .matching-time {
        width: 50%;
        font-size: 13px;
        color: colors.$concrete-color;

        .material-icons {
          font-size: 13px;
          margin-left: 0.25em;
          padding-bottom: 0.35em;
        }
      }
    }
  }
}
</style>
